import React, {useEffect, useState} from "react";
import style from "../../../../assets/scss/common/modal/addConsultationModal.module.scss";
import CloseBtn from "../../../../assets/images/modal/close_btn.svg";
import {useModal} from "../../../../hooks/hooks";
import {
  ConsultationCancelDTO,
  ConsultationItem,
  ConsultationPutDTO,
  ConsultationReservation
} from "../../../../types/consultation";
import {ReservationProfileInfo} from "./ReservationProfileInfo";
import {ReservationTitle} from "./ReservationTitle";
import {ReservationDateInput} from "./ReservationDateInput";
import {ReservationInquiry} from "./ReservationInquiry";
import {useConsultationReservationValidator} from "../../hooks/useConsultationReservationValidator";
import {useConsultationGetter} from "../../../sub/consultation/hooks/useConsultationGetter";
import {useConsultationFunctions} from "../../../sub/consultation/hooks/useConsultationFunctions";
import {useModalScrollLock} from "./hooks/useModalScrollLock";
import {useTranslation} from "react-i18next";

interface AddChildModalProps {
  isOpen: boolean;
  selectedConsultation: ConsultationItem | null;
  onClose: () => void;
  onRefresh: () => void;
}

const EditConsultationModal: React.FC<AddChildModalProps> = (
    {isOpen, selectedConsultation, onClose, onRefresh}) => {
  const { t } = useTranslation("consultant");
  useModalScrollLock(isOpen); // 모달 밖 스크롤 제한

  const {openConfirmModal, openAlertModal} = useModal();
  const {getConsultationStatus} = useConsultationFunctions();
  const [selectedDate, setSelectedDate] = useState("연도-월-일");
  const [selectedTime, setSelectedTime] = useState("");
  const [reservationIdx, setReservationIdx] = useState(0);
  const [childName, setChildName] = useState("");
  const [testInfo, setTestInfo] = useState("");
  const [inquiry, setInquiry] = useState("");
  const [availableTimes, setAvailableTimes] = useState<ConsultationReservation[]>([]); // 잔여석 데이터

  const {updateCounseling, cancelCounseling} = useConsultationGetter();

  const {getConsultationInfo, consultationData,
    getAvailableReservation, reservationList} = useConsultationGetter();

  useEffect(() => {
    if (isOpen && selectedConsultation && selectedConsultation.userName) {
      getConsultationInfo(selectedConsultation.counselingIdx).then();
      const {userName, testRound, unitVoucherType} = selectedConsultation;
      setChildName(userName)
      setTestInfo(`${unitVoucherType} ${testRound}회차`)
    }
    // eslint-disable-next-line
  }, [selectedConsultation]);

  useEffect(() => {
    if (consultationData) {
      setReservationIdx(consultationData.reservationIdx)
      setSelectedDate(consultationData.desiredDate)
      setSelectedTime(consultationData.desiredTime)
      setInquiry(consultationData.preQuestioning)

      getAvailableReservation({
        desiredDate:consultationData.desiredDate}
      ).then()
    }
    // eslint-disable-next-line
  }, [consultationData]);

  useEffect(() => {
    setAvailableTimes(reservationList)
  }, [reservationList]);

  const {isInquiryValidate, validate, setInquiryValidate} = useConsultationReservationValidator(
      {desiredTime: selectedTime, desiredDate: selectedDate, inquiry: inquiry}
  )
  useEffect(() => {
  }, [getConsultationInfo]);

  const isFormValid = () => {
    return childName && selectedDate !== "연도-월-일" && selectedTime && inquiry.length >= 3;
  };

  if (!isOpen) {
    return null;
  }

  const handleEditConsultation = () =>{
    const validator = validate();
    if(!validator) return alert("상담 작성폼을 다시 확인해주세요.");
    if(selectedConsultation === null) return;
    if(consultationData === undefined) return;

    openConfirmModal({
      title: t('modal.title'),
      desc: t('modal.modify.desc2')
    },() =>{
      const body:ConsultationPutDTO = {
        userProfileIdx: selectedConsultation.profileIdx,
        counselingReservationIdx: reservationIdx,
        preQuestioning:inquiry
      }
      updateCounseling({body:body, idx: consultationData.counselingIdx}).then(() =>{
        openAlertModal({
          title: t('modal.title'),
          desc: t('modal.modify.complete')
        })
        onClose();
        onRefresh();
      })
    })

  }

  const cancelConsultation = () =>{
    if (!consultationData || !selectedConsultation) {
      alert("일시적인 문제가 발생했습니다.\n다시 시도해주세요.")
      window.location.reload();
      return;
    }

    const body:ConsultationCancelDTO = {
      counselingIdx: consultationData?.counselingIdx,
      counselingReservationIdx: consultationData?.reservationIdx,
      userProfileIdx: selectedConsultation?.profileIdx,
    }

    openConfirmModal(
        {
          title: t('modal.title'),
          desc: `${t('modal.cancel.desc1')}\n${t('modal.cancel.desc2')}`,
        },
        () => {
          cancelCounseling(body).then(() =>{
            openAlertModal({
              title: t('modal.title'),
              desc: t('modal.cancel.complete'),
            })
            onClose();
            onRefresh();
          });
        }
    );

  }

  return (
      <div className={style.addChildModalOverlay}>
        <div className={style.addChildInfoModal}>
          <div className={style.closeBtnContainer}>
            <img
                src={CloseBtn}
                alt="closeBtn"
                className={style.closeBtn}
                onClick={() => {
                  openConfirmModal(
                      {
                        title: t('modal.title'),
                        desc: `${t('modal.apply.desc3')}\n${t('modal.apply.desc4')}\n${t('modal.apply.desc5')}`,
                      },
                      () => {
                        onClose();
                      }
                  );
                }}
            />
          </div>
          <div className={style.innerModalContainer}>
            <ReservationTitle/>
            <ReservationProfileInfo childName={childName} testInfo={testInfo}/>
            <ReservationDateInput
                selectedDate={selectedDate} setSelectedDate={setSelectedDate}
                selectedTime={selectedTime} setSelectedTime={setSelectedTime}
                availableTimes={availableTimes} setAvailableTimes={setAvailableTimes}
                setReservationIdx={setReservationIdx}
            />
            <ReservationInquiry inquiry={inquiry} setInquiry={setInquiry}
                                isInquiryValidate={isInquiryValidate} setIsInquiryValidate={setInquiryValidate}/>
            <div className={style.innerTextContainer}>
              <div className={style.infoContainer}>
                <span className={style.infoTitleText}>{t('detail.modal.status.title')}</span>
                <div className={style.marginDiv}>
                  {getConsultationStatus(consultationData?.status)}
                </div>
              </div>
            </div>

            <div className={style.cancelBtnContainer} onClick={cancelConsultation}>
              <button className={style.cancelBtn}>{t('detail.modal.status.canceled')}</button>
            </div>
            <button
                className={style.submitBtn}
                onClick={() => handleEditConsultation()}
                disabled={!isFormValid()}
            >
              {t('modal.modify.desc1')}
            </button>
          </div>
        </div>
      </div>
  );
};

export default EditConsultationModal;
